import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetFullfillableSlots_booking$key } from "./__generated__/useGetFullfillableSlots_booking.graphql";

export const useGetFullfillableSlots = ({
  bookingFragmentRef,
}: {
  bookingFragmentRef?: useGetFullfillableSlots_booking$key | null;
}) => {
  const booking = useFragment(
    useGetFullfillableSlotsFragmentString,
    bookingFragmentRef
  );

  return booking?.fullfillableSlots ?? [];
};

const useGetFullfillableSlotsFragmentString = graphql`
  fragment useGetFullfillableSlots_booking on Booking {
    ... on StandardBooking {
      fullfillableSlots {
        id
        ... on TimeSlot {
          time
          availability
          course {
            name
          }
          slotRates: playerRates(type: CUSTOMER, highestPrecedentOnly: true) {
            nineHolePrice: totalGolfPrice(holeCount: NINE)
            eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)
            rate {
              name
            }
          }
        }
      }
    }
  }
`;
